import { useEffect } from "react";
import { loaderActions } from "../../redux/slices/loadingSlice";
import { useAppDispatch } from "../../redux/store";
import useCookiesCheck from "../../utils/useCookiesCheck";
import Documents from "./Documents/Documents";
import Flights from "./Flights/Flights";
import Hotels from "./Hotels/Hotels";
import LMXTools from "./LMXTools/LMXTools";
import MainInfo from "./MainInfo/MainInfo";
import Payments from "./Payments/Payments";
import Remarks from "./Remrks/Remarks";
import Transfers from "./Transfers/Transfers";
import { useNavigate } from "react-router-dom";
import { ImExit } from "react-icons/im";
import { MdEditDocument } from "react-icons/md";

const BookingDetailsPage = () => {
  useCookiesCheck();
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(loaderActions.hideLoader());
  }, []);

  const logout = () => {
    sessionStorage.removeItem("lmxBooking");
    window.location.href = "/MyLmxApp";
  };

  const isAdmin = sessionStorage.getItem("adminAuthenticated") === "true";

  return (
    <div className="bookingDetails">
      <div className="container mt-5">
        <div className="flex items-center gap-2 justify-end">
          {isAdmin && (
            <button
              className="btnRounded flex items-center gap-3"
              onClick={() => navigate("/admin/booking")}
            >
              <MdEditDocument />
              Change Booking
            </button>
          )}
          <button className="btnRounded flex items-center gap-3" onClick={logout}>
            <ImExit />
            Logout
          </button>
        </div>

        <LMXTools />
        <MainInfo />
        <Flights />
        <Hotels />
        <Transfers />
        <Remarks />
        <Documents />
        <Payments />
        <LMXTools />
      </div>
    </div>
  );
};

export default BookingDetailsPage;
